/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_2Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once the numbers behave as expected, apply a consistent number format and save the workbook. Reopen the saved file and repeat the quantity change. You have now practiced the essential loop: structure inputs, calculate results, make a controlled edit and keep a reusable file. The exercise also shows why a spreadsheet is different from a static table in a document.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认数字正确后，设置统一数字格式并保存工作簿。重新打开文件，再试一次数量修改。至此你完成了基础闭环：组织输入、计算结果、做可控修改并保存可复用文件。这也说明电子表格与文档中的静态表格有何不同。`)
};

/**
* | output |
* | --- |
* | "Once the numbers behave as expected, apply a consistent number format and save the workbook. Reopen the saved file and repeat the quantity change. You have n..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_5_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_2(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_2(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_5_paragraphs_2 as "gc.search_guides.what_is_gridcraft.sections.5.paragraphs.2" }